// src/App.js
import React, { useEffect } from 'react';
import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import Dashboard from './components/dashboard/Dashboard'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProtectedRoute from './components/ProtectedRoute';
import Profile from './features/profile/Profile';
import LayoutDefault from './layout/LayoutDefault';
import ClientSignUp from './components/clientSignup/ClientSignUp';
import SignUp from './components/signup/SignUp';
import AssignedClients from './components/clientSignup/AssignedClients';
import ActiveClients from './components/clientSignup/ActiveClients';
import InactiveClients from './components/clientSignup/InactiveClients';
import AllClients from './components/clientSignup/AllClients';
import PendingClients from './components/clientSignup/PendingClients';
import Unauthorized from './components/Unauthorized';
import RejectedInfluencers from './components/clientInfluencer/RejectedInfluencers';
import SuggestedInfluencers from './components/clientInfluencer/SuggestedInfluencers';
import ApprovedInfluencers from './components/clientInfluencer/ApprovedInfluencers';
import ActiveInfluencer from './components/dmExecutive/ActiveInfluencer';
import InactiveInfluencer from './components/dmExecutive/InactiveInfluencer';
import AllInfluencer from './components/dmExecutive/AllInfluencer';
import DetailInfluencer from './components/dmExecutive/DetailInfluencer';
import PendingInfluencer from './components/dmExecutive/PendingInfluencer';
import AssignedInfluencer from './components/dmExecutive/AssignedInfluencer';

import ClientRequest from './components/clientRequest/ClientRequest';
import DetailClients from './components/clientSignup/DetailClients';
import InfuencerRequest from './components/dmRequest/InfuencerRequest';
import ChangePassword from './components/profile/ChangePassword';
import ClientInfluencerRequest from './components/clientInfluencerRequest/ClientInfluencerRequest';
import ClientInfluencerRequestDetails from './components/clientInfluencerRequest/ClientInfluencerRequestDetails';
import ClientInfluencerRequestDmTLDetails from './components/clientInfluencerRequest/ClientInfluencerRequestDmTLDetails';
import SugestedInfluencerDetails from './components/clientInfluencerRequest/SugestedInfluencerDetails';
import SugestedInfluencer from './components/clientInfluencerRequest/SugestedInfluencer';
import SuggestedInfluencerBySales from './components/clientInfluencerRequest/SuggestedInfluencerBySales';
import SuggestedInfluencerBySalesDetails from './components/clientInfluencerRequest/SuggestedInfluencerBySalesDetails';
import ClientInfluencerRequestDmTL from './components/clientInfluencerRequest/ClientInfluencerRequestDmTL';
import ApprovedUpdateInfluencers from './components/clientInfluencer/ApprovedUpdateInfluencers';
import DetailRequestClient from './components/dmExecutive/DetailRequestClient';
import SuggestedRequestDetails from './components/dmExecutive/SuggestedRequestDetails';
import RequestInfluencerDetails from './components/dmExecutive/RequestInfluencerDetails';
import UpcomingVideo from './components/videos/UpcomingVideo';
import ClientVideoDetails from './components/videos/ClientVideoDetails';
import DmTlSuggestedInfluencer from './components/clientInfluencerRequest/DmTlSuggestedInfluencer';
import SuggestedDmTlInfluencerDetails from './components/clientInfluencerRequest/SuggestedDmTlInfluencerDetails';
import AccessInfRequest from './components/clientInfluencer/AccessInfRequest';
import InfluencerUpdate from './components/dmExecutive/InfluencerUpdate';
import Finance from './components/finance/Finance';
import InvoicesDetails from './components/finance/InvoicesDetails';
import InfFinDetails from './components/finance/InfFinDetails';
import UserRegister from './components/userRegister/UserRegister';

// Swagger
import InfDiscovery from './components/swagger/Discovery';

// tinyurl
import TinyUrlList from './components/common/TinyurlList';

//External
import ReportExternal from './components/dmExecutive/ReportExternal';
import ReportList from './components/dmExecutive/ReportList';
import LiveReportList from './components/dmExecutive/ReportLiveList';
import InfluencerDiscover from './components/discover/InfluencerDiscover'
import InfluencerInsights from './components/insights/InfluencerInsights'
import InfluencerExport from './components/export/InfluencerExport'
import Setting from './components/profile/Setting';
import UpdateUserDetails from './components/userRegister/UpdateUserDetails';
import ResetUserPassword from './components/userRegister/ResetUserPassword';
import UserDataList from './components/userRegister/UserDataList';
import InfluencerRegister from './components/signup/InfluencerRegister';
import InternalBidding from './components/clientInfluencerRequest/InternalBidding';
import InternalBiddingDetails from './components/clientInfluencerRequest/InternalBiddingDetails';
import TaskTracker from './components/taskTracker/TaskTracker';
import DoneTaskList from './components/taskTracker/DoneTaskList';
import SuggestedInfluencerData from './components/dmExecutive/SuggestedInfluencerData';
import SuggestedInfluencerDetails from './components/dmExecutive/SuggestedInfluencerDetails';
import InfluencerProfile from './components/discover/InfluencerProfileAnalysis';






function PageTitleUpdater() {
  const location = useLocation();

  useEffect(() => {
    // Map route path to the title
    const titles = {
      '/': 'Home',
      '/dashboard': 'Dashboard',
      '/profile': 'Profile',
      '/client-sign-up': 'Client Sign Up',
      '/sign-up': 'Sign Up',
      '/client-all-request': 'All Requests',
      '/suggested-influencer-by-sales': 'Suggested Influencers',
      '/approved-suggested-influencer-by-sales': 'Approved Influencers',
      '/rejected-suggested-influencer-by-sales': 'Rejected Influencers',
      '/upcoming-videos': 'Upcoming Videos',
      '/post-videos': 'Post Videos',
      '/all-videos': 'All Videos',
      '/pending-clients': 'Pending Clients',
      '/client-request-in-sales': 'All Clients Request',
      '/suggested-influencer-list': 'Suggested Influencers',
      '/approved-suggested-influencer-list': 'Approved Influencers',
      '/rejected-suggested-influencer-list': 'Rejected Influencers',
      '/ongoing-list': 'Suggested Clinet',
      '/completed-list': 'Approved Clinet',

      '/client-request-in-dm': 'All Client Request',
      '/client-sub-request-in-dm-tl': 'Suggested Influencer',
      '/approved-client-sub-request-in-dm-tl': 'Approved Influencer',
      '/rejected-client-sub-request-in-dm-tl': 'Rejected Influencer',
      '/influencer-access-request-in-dm-tl': 'All Videos',
      '/assigned-influencer': 'Assigned Influencer',
      '/suggested-influencer': 'Influencer Sub Request List',
      '/rejected-influencers': 'Rejected Influencers',
      '/suggested-influencers': 'Suggested Influencers',
       '/suggested-inf-list': 'Suggested Influencers',
      '/assigned-clients': 'Assigned Clients',
      '/active-clients': 'Active Clients',
      '/inactive-clients': 'Inactive Clients',
      '/all-clients': 'All Clients',
      '/active-influencer': 'Active Influencer',
      '/inactive-influencer': 'Inactive Influencer',
      '/pending-influencer': 'Pending Influencer',
      '/all-influencer': 'All Influencers',
      '/influencer-discover': 'Influencers Discover',
      '/influencer-insights': 'Influencers Insights',
      '/exports-list': 'Export List',
      '/task-tracker': 'Task Tracker',
      '/task-tracker/done': 'Done Tasks',
      '/unauthorized': 'Unauthorized',
      '/update-user-details': 'Update user',
      '/reset-user-password': 'Reset user password',
      '/create-new-user': "Add new user",
      '/registered-user-list': "User list",
      '/influencer-register': "Influencer Register",
      '/surggested-influencer-details-by-id': 'Suggested influencer list',
      '/influencer-profile/:channelName/:username': 'Influencer Profile',
      // Add more routes as needed...
    };

    // Set the document title based on the current location
    document.title = titles[location.pathname] || 'My Application'; // Default title if no match

  }, [location]);

  return null;
}


function App() {


  return (
    <>

      <ToastContainer />
      <PageTitleUpdater />
      <Routes>
        {/* Login */}
        <Route path="/" element={<LayoutDefault />} />
        {/* New User Register */}
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/client-sign-up" element={<ClientSignUp />} />

        <Route path="/client-sign-up/website" element={<ClientSignUp />} />
        {/* <Route path="/client-sign-up/referal_id/:id" element={<ClientSignUp />} /> */}
        {/* Dashboard */}
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        {/* Setting */}
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
        <Route path="/task-tracker" element={<ProtectedRoute><TaskTracker /></ProtectedRoute>} />
        <Route path="/task-tracker/done" element={<ProtectedRoute><DoneTaskList /></ProtectedRoute>} />
        {/* Error Page */}
        <Route path="/unauthorized" element={<Unauthorized />} />

        <Route path='/influencer-update-details/:id' element={<ProtectedRoute><InfluencerUpdate /></ProtectedRoute>} />
        {/* Other Page */}
        <Route path="/influencer-register" element={<ProtectedRoute><InfluencerRegister /></ProtectedRoute>} />
        <Route path="/client-all-request" element={<ProtectedRoute><ApprovedInfluencers /></ProtectedRoute>} />
        <Route path="/client-update-request" element={<ProtectedRoute><ApprovedUpdateInfluencers /></ProtectedRoute>} />
        <Route path="/rejected-influencers" element={<ProtectedRoute><RejectedInfluencers /></ProtectedRoute>} />
        <Route path="/suggested-influencers" element={<ProtectedRoute><SuggestedInfluencers /></ProtectedRoute>} />
        <Route path="/assigned-clients" element={<ProtectedRoute><AssignedClients /></ProtectedRoute>} />
        <Route path="/active-clients" element={<ProtectedRoute><ActiveClients /></ProtectedRoute>} />
        <Route path="/pending-clients" element={<ProtectedRoute><PendingClients /></ProtectedRoute>} />
        <Route path="/inactive-clients" element={<ProtectedRoute><InactiveClients /></ProtectedRoute>} />
        <Route path="/all-clients" element={<ProtectedRoute><AllClients /></ProtectedRoute>} />
        <Route path="/active-influencer" element={<ProtectedRoute><ActiveInfluencer /></ProtectedRoute>} />
        <Route path="/inactive-influencer" element={<ProtectedRoute><InactiveInfluencer /></ProtectedRoute>} />
        <Route path="/pending-influencer" element={<ProtectedRoute><PendingInfluencer /></ProtectedRoute>} />
        <Route path="/all-influencer" element={<ProtectedRoute><AllInfluencer /></ProtectedRoute>} />
        <Route path="/assigned-influencer" element={<ProtectedRoute><AssignedInfluencer /></ProtectedRoute>} />
        <Route path="/client-request-in-sales" element={<ProtectedRoute><ClientRequest /></ProtectedRoute>} />
        <Route path="/client-details/:id" element={<ProtectedRoute><DetailClients /></ProtectedRoute>} />
        <Route path="/influencer-details/:id" element={<ProtectedRoute><DetailInfluencer /></ProtectedRoute>} />
        <Route path="/client-request-details/:id" element={<ProtectedRoute><DetailRequestClient /></ProtectedRoute>} />
        <Route path="/client-request-in-dm" element={<ProtectedRoute><InfuencerRequest /></ProtectedRoute>} />

        <Route path="/surggested-influencer-details-by-id/:id" element={<ProtectedRoute><SuggestedInfluencerDetails /></ProtectedRoute>} />

        

        <Route path="/suggested-inf-list" element={<ProtectedRoute><SuggestedInfluencerData /></ProtectedRoute>} />
        <Route path="/suggested-influencer" element={<ProtectedRoute><ClientInfluencerRequest /></ProtectedRoute>} />
        <Route path="/approved-influencer" element={<ProtectedRoute><ClientInfluencerRequest /></ProtectedRoute>} />
        <Route path="/rejected-influencer" element={<ProtectedRoute><ClientInfluencerRequest /></ProtectedRoute>} />

        <Route path="/client-influencer-request-details/:id" element={<ProtectedRoute><ClientInfluencerRequestDetails /></ProtectedRoute>} />

        <Route path="/client-sub-request-in-dm-tl" element={<ProtectedRoute><ClientInfluencerRequestDmTL /></ProtectedRoute>} />
        <Route path="/approved-client-sub-request-in-dm-tl" element={<ProtectedRoute><ClientInfluencerRequestDmTL /></ProtectedRoute>} />
        <Route path="/rejected-client-sub-request-in-dm-tl" element={<ProtectedRoute><ClientInfluencerRequestDmTL /></ProtectedRoute>} />
        <Route path="/client-influencer-request-details-dm-tl/:id" element={<ProtectedRoute><ClientInfluencerRequestDmTLDetails /></ProtectedRoute>} />
        <Route path="/approved-client-influencer-request-details-dm-tl/:id" element={<ProtectedRoute><ClientInfluencerRequestDmTLDetails /></ProtectedRoute>} />
        <Route path="/rejected-client-influencer-request-details-dm-tl/:id" element={<ProtectedRoute><ClientInfluencerRequestDmTLDetails /></ProtectedRoute>} />



        <Route path="/suggested-influencer-list" element={<ProtectedRoute><SugestedInfluencer /></ProtectedRoute>} />
        <Route path="/approved-suggested-influencer-list" element={<ProtectedRoute><SugestedInfluencer /></ProtectedRoute>} />
        <Route path="/rejected-suggested-influencer-list" element={<ProtectedRoute><SugestedInfluencer /></ProtectedRoute>} />
        <Route path="/ongoing-list" element={<ProtectedRoute><InternalBidding /></ProtectedRoute>} />
        <Route path="/completed-list" element={<ProtectedRoute><InternalBidding /></ProtectedRoute>} />

        <Route path="/ongoing-details/:id" element={<ProtectedRoute><InternalBiddingDetails /></ProtectedRoute>} />
        <Route path="/completed-details/:id" element={<ProtectedRoute><InternalBiddingDetails /></ProtectedRoute>} />
        <Route path="/ongoing-onboarding-details/:id" element={<ProtectedRoute><InternalBiddingDetails /></ProtectedRoute>} />
        <Route path="/completed-onboarding-details/:id" element={<ProtectedRoute><InternalBiddingDetails /></ProtectedRoute>} />


        <Route path="/ongoing-onboarding-bidding-list" element={<ProtectedRoute><InternalBidding /></ProtectedRoute>} />
        <Route path="/completed-onboarding-bidding-list" element={<ProtectedRoute><InternalBidding /></ProtectedRoute>} />

        <Route path="/ongoing-onboarding-bidding-details/:id" element={<ProtectedRoute><InternalBiddingDetails /></ProtectedRoute>} />
        <Route path="/completed-onboarding-bidding-details/:id" element={<ProtectedRoute><InternalBiddingDetails /></ProtectedRoute>} />


        <Route path="/suggested-influencer-details/:id" element={<ProtectedRoute><SugestedInfluencerDetails /></ProtectedRoute>} />
        <Route path="/approved-suggested-influencer-details/:id" element={<ProtectedRoute><SugestedInfluencerDetails /></ProtectedRoute>} />
        <Route path="/rejected-suggested-influencer-details/:id" element={<ProtectedRoute><SugestedInfluencerDetails /></ProtectedRoute>} />

        <Route path="/suggested-dmtl-influencer-list" element={<ProtectedRoute><DmTlSuggestedInfluencer /></ProtectedRoute>} />
        <Route path="/approved-dmtl-suggested-influencer-list" element={<ProtectedRoute><DmTlSuggestedInfluencer /></ProtectedRoute>} />
        <Route path="/rejected-dmtl-suggested-influencer-list" element={<ProtectedRoute><DmTlSuggestedInfluencer /></ProtectedRoute>} />
        <Route path="/suggested-dmtl-influencer-details/:id" element={<ProtectedRoute><SuggestedDmTlInfluencerDetails /></ProtectedRoute>} />
        <Route path="/approved-dmtl-suggested-influencer-details/:id" element={<ProtectedRoute><SuggestedDmTlInfluencerDetails /></ProtectedRoute>} />
        <Route path="/rejected-dmtl-suggested-influencer-details/:id" element={<ProtectedRoute><SuggestedDmTlInfluencerDetails /></ProtectedRoute>} />

        <Route path="/suggested-influencer-details_by_unique/:id" element={<ProtectedRoute><SuggestedRequestDetails /></ProtectedRoute>} />
        <Route path="/approved-suggested-influencer-details_by_unique/:id" element={<ProtectedRoute><SuggestedRequestDetails /></ProtectedRoute>} />
        <Route path="/rejected-suggested-influencer-details_by_unique/:id" element={<ProtectedRoute><SuggestedRequestDetails /></ProtectedRoute>} />

        <Route path="/influencer-request-details" element={<ProtectedRoute><RequestInfluencerDetails /></ProtectedRoute>} />


        <Route path="/suggested-influencer-by-sales" element={<ProtectedRoute><SuggestedInfluencerBySales /></ProtectedRoute>} />
        <Route path="/approved-suggested-influencer-by-sales" element={<ProtectedRoute><SuggestedInfluencerBySales /></ProtectedRoute>} />
        <Route path="/rejected-suggested-influencer-by-sales" element={<ProtectedRoute><SuggestedInfluencerBySales /></ProtectedRoute>} />
        <Route path="/suggested-influencer-by-sales-details/:id" element={<ProtectedRoute><SuggestedInfluencerBySalesDetails /></ProtectedRoute>} />
        <Route path="/approved-suggested-influencer-by-sales-details/:id" element={<ProtectedRoute><SuggestedInfluencerBySalesDetails /></ProtectedRoute>} />
        <Route path="/rejected-suggested-influencer-by-sales-details/:id" element={<ProtectedRoute><SuggestedInfluencerBySalesDetails /></ProtectedRoute>} />

        <Route path="/suggested-influencer-by-sales-details_by_unique/:id" element={<ProtectedRoute><SuggestedRequestDetails /></ProtectedRoute>} />
        <Route path="/approved-suggested-influencer-by-sales-details_by_unique/:id" element={<ProtectedRoute><SuggestedRequestDetails /></ProtectedRoute>} />
        <Route path="/rejected-suggested-influencer-by-sales-details_by_unique/:id" element={<ProtectedRoute><SuggestedRequestDetails /></ProtectedRoute>} />

        <Route path="/upcoming-videos" element={<ProtectedRoute><UpcomingVideo /></ProtectedRoute>} />
        <Route path="/post-videos" element={<ProtectedRoute><UpcomingVideo /></ProtectedRoute>} />
        <Route path="/all-videos" element={<ProtectedRoute><UpcomingVideo /></ProtectedRoute>} />
        <Route path="/upcoming-video-details/:id" element={<ProtectedRoute><ClientVideoDetails /></ProtectedRoute>} />
        <Route path="/post-video-details/:id" element={<ProtectedRoute><ClientVideoDetails /></ProtectedRoute>} />
        <Route path="/all-video-details/:id" element={<ProtectedRoute><ClientVideoDetails /></ProtectedRoute>} />


        <Route path="/influencer-access-request-in-dm-tl" element={<ProtectedRoute><AccessInfRequest /></ProtectedRoute>} />


        <Route path="/pending-invoices" element={<ProtectedRoute><Finance /></ProtectedRoute>} />
        <Route path="/completed-invoices" element={<ProtectedRoute><Finance /></ProtectedRoute>} />
        <Route path="/cencelled-invoices" element={<ProtectedRoute><Finance /></ProtectedRoute>} />
        <Route path="/all-invoices" element={<ProtectedRoute><Finance /></ProtectedRoute>} />

        <Route path="/pending-invoices-details/:id" element={<ProtectedRoute><InvoicesDetails /></ProtectedRoute>} />
        <Route path="/completed-invoices-details/:id" element={<ProtectedRoute><InvoicesDetails /></ProtectedRoute>} />
        <Route path="/cencelled-invoices-details/:id" element={<ProtectedRoute><InvoicesDetails /></ProtectedRoute>} />
        <Route path="/invoices-details/:id" element={<ProtectedRoute><InvoicesDetails /></ProtectedRoute>} />
        <Route path="/influencer-detail/:id" element={<ProtectedRoute><InfFinDetails /></ProtectedRoute>} />

        <Route path="/registered-user-list" element={<ProtectedRoute><UserDataList /></ProtectedRoute>} />
        <Route path="/create-new-user" element={<ProtectedRoute><UserRegister /></ProtectedRoute>} />

        <Route path="/task-tracker" element={<ProtectedRoute><TaskTracker /></ProtectedRoute>} />
        <Route path="/task-tracker/done" element={<ProtectedRoute><DoneTaskList /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute><ReportExternal /></ProtectedRoute>} />
        <Route path="/report-list" element={<ProtectedRoute><ReportList /></ProtectedRoute>} />
        <Route path="/live-report-list" element={<ProtectedRoute><LiveReportList /></ProtectedRoute>} />

        {/* Swagger */}
        <Route path="/inf-discovery" element={<ProtectedRoute><InfDiscovery /></ProtectedRoute>} />

        {/* tiny url */}
        <Route path="/tinyurl-list" element={<ProtectedRoute><TinyUrlList /></ProtectedRoute>} />

        <Route path='/influencer-discover' element={<ProtectedRoute><InfluencerDiscover /></ProtectedRoute>} />
        <Route path='/influencer-insights' element={<ProtectedRoute><InfluencerInsights /></ProtectedRoute>} />
        <Route path='/exports-list' element={<ProtectedRoute><InfluencerExport /></ProtectedRoute>} />
        <Route path='/setting' element={<ProtectedRoute><Setting /></ProtectedRoute>} />

        <Route path='/update-user-details/:id' element={<ProtectedRoute><UpdateUserDetails /></ProtectedRoute>} />
        <Route path='/reset-user-password/:id' element={<ProtectedRoute><ResetUserPassword /></ProtectedRoute>} />
        <Route path='/influencer-profile/:username' element={<ProtectedRoute><InfluencerProfile /></ProtectedRoute>} />

        

      </Routes>
    </>
  );
}

export default App;
